
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Home from './Home/Home';
// import ScrollToTop from "./ScrollToTop"; 

import Servicesconstruction from './services/Servicesconstruction';

import Aboutcivil from './about/Aboutcivil';
import AllServices from './ourservices/mainservices';
import Callproject from './Cproject/Callproject';
import Contact from './contact/Contact';
import Ourteam from './ourteam/Ourteam';
import Gallery from './gallery/galley';
import Realestate from './realestate/Realestate';
import Thankspage from './Thankspage/Thanks';
import Interiorpage from '../Componentsinterior/interiorpage/Interiorpage';
import Portfoliopagemain from '../Componentsinterior/Portfolio/Portfoliopagemain';
import Architecture from '../Componentsinterior/architecture/Architecture';
import Projectmanagement from '../Componentsinterior/projectmanagement/Projectmanagement';
import Thankyoupage from '../Componentsinterior/Thankspage/Thanks';
import Homemain from './Home/homemain';
// import Popupcontact from '../Componentsinterior/popupcontact/Popupcontact';

function Routepath() {
  return (
    <Router>
     
      <Routes>
        <Route path = "/" element={<Homemain/>}/>
    

        <Route path="/constructionpage" element={<Servicesconstruction />} />
     
        <Route path='/about/civil' element={<Aboutcivil/>}/>
        <Route path = "/all-service" element={<AllServices/>}/>
        <Route path = "/all-project" element={<Callproject/>}/>
        <Route path = "/contact" element={<Contact/>}/>
        <Route path='/ourteam' element={<Ourteam/>}/>
        <Route path = "/gallery" element={<Gallery/>}/>
        <Route path = "/real-estate" element= {<Realestate/>}/>
        <Route path = "/gallery" element={<Gallery/>}/>
        <Route path = "/thankyou" element = {<Thankspage/>}/>
        
        {/* You can add more routes here if needed */}
        <Route path='/interiorpage' element={<Interiorpage/>}/>
        <Route path ="/portfoliopage" element = {<Portfoliopagemain/>}/>
        <Route path="/portfoliopage/:category/:title" element={<Portfoliopagemain />} />
        {/* <Route path = "/contact-page" element={<Popupcontact/>}/> */}
        <Route path = "/architecture" element={<Architecture/>}/>
        <Route path = "/projectmanagement" element = {<Projectmanagement/>}/>
        <Route path = "/thank_you" element = {<Thankyoupage/>}/>
      </Routes>
    </Router>
  );
}


export default Routepath;
